import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PageShell from '../../components/PageShell';
import PrintReportDocument from '../PrintReportDocument';
import { useRegisterPageExports } from '../../exports/pageExports';
import PeopleStory from './PeopleStory';
import PeopleImportModal from './PeopleImportModal';

/* Synthèse — le récit (2026-08-21).

   Deux écrans répondaient à la même question sans se parler : « où j'en suis »
   (Chiffres clés) et « d'où je viens » (Évolution). Les lire l'un après
   l'autre laissait au lecteur le travail de rapprochement — celui qui produit
   justement l'information utile.

   Le récit l'assume : des chapitres aimantés au défilement, un écran chacun,
   une phrase et un chiffre. Il ne CRÉE aucune donnée — il ordonne celles des
   deux autres sections et les rapproche.

   Le chapitre « Agir » qui le CONCLUAIT est retiré (2026-08-26) : une synthèse
   se lit, et des raccourcis posés après le dernier chapitre ne se voyaient
   qu'une fois tout parcouru. Trois portes les remplacent EN OUVERTURE — lire,
   mettre à jour, simuler — parce que c'est là qu'on choisit ce qu'on vient
   faire. La page hôte fournit les gestes : le récit ne connaît ni la
   navigation ni les modales, il se contente de leur faire une place. */
export default function PeopleStoryPage({
  activeTenant, setPage, year, onYearChange, addToast, onGoPeople,
}) {
  const { t } = useTranslation();
  const [showData, setShowData] = useState(false);

  /* PDF du récit — une diapositive = une page. Pas d'Excel : le récit est fait
     de phrases et de figures-clés, il n'a pas de tableau à donner (les chiffres
     se sortent depuis « Chiffres clés », juste à côté dans le menu). */
  const [showPrint, setShowPrint] = useState(false);
  useRegisterPageExports(useMemo(() => ([
    { id: 'pdf', label: 'PDF', run: () => setShowPrint(true) },
  ]), []));

  return (
    <PageShell title={t('people:story.title')}>
      <PeopleStory activeTenant={activeTenant} year={year} onYearChange={onYearChange}
                   onGo={() => setPage('hr-synthese')} />

      {showData && activeTenant && (
        <PeopleImportModal
          tenantId={activeTenant.id}
          year={year}
          addToast={addToast}
          onAddPerson={() => onGoPeople && onGoPeople({ tab: 'people', action: 'add' })}
          onClose={() => setShowData(false)}
        />
      )}

      {showPrint && (
        <PrintReportDocument
          activeTenant={activeTenant}
          year={year}
          reports={['people-story']}
          mode="pdf"
          onClose={() => setShowPrint(false)}
        />
      )}
    </PageShell>
  );
}
